<div class="container">

  <app-header-dialog [iconName]="'post_add'">
    Aprovação
  </app-header-dialog>

  <div class='content'>

    <form name="entityForm" [formGroup]='entityForm' autocomplete="off">

      <mat-select (ngModelChange)='selectFolder($event)' [formControl]="entityForm.controls.folder_id"
        style="width: 520px; background-color: whitesmoke; padding: 5px 0 5px 5px;">
        <mat-option *ngFor="let folder of folders" [value]="folder.id">
          {{ folder.name }}
        </mat-option>
      </mat-select>

      <div style="margin-top: 20px;">

        <mat-form-field class="full-width" appearance="outline">
          <mat-label>Nome do Arquivo</mat-label>
          <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.filename"
            autocomplete="off">
          <mat-error *ngIf="entityForm.controls.filename.hasError('required')">
            O nome é obrigatório
          </mat-error>
        </mat-form-field>

        <mat-checkbox class="staff-width" color='primary' [formControl]="entityForm.controls.approved">
          <span>Aprovado</span>
        </mat-checkbox>

      </div>

    </form>
  </div>

  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
    <button mat-raised-button class="flat-button" mat-dialog-close
      (click)="matDialogRef.close([ entityForm, selectedFolder ])">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>
  </div>

</div>